import { useQuery } from "@apollo/client";
import AppConfig from "AppSettings";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useModals } from "ModalProvider";
import { createContext } from "react";
import { useParams } from "react-router-dom";
import { FETCH_PRODUCT_LINE_DETAIL } from "../graphql";
import OneProductView from "./OneProductView";
import ProductCostHistoryView from "./ProductCostHistoryView";
import ProductWithBomCostHistoryView from "./ProductWithBomCostHistoryView";

export const ProductCostContext = createContext({});

const ProductDetail = () => {
  const { id, company } = useParams();
  const { loading, error, data } = useQuery(FETCH_PRODUCT_LINE_DETAIL, {
    variables: { id, company },
    fetchPolicy: "network-only",
  });

  const defaultCurrency = company === "AB" ? "USD" : "RMB";

  const costHistoryModal = useModals();

  function showProductWithBomCostHistory(id) {
    costHistoryModal.present({
      title: "Product Cost History",
      maxWidth: "max-w-full",
      children: (
        <ProductWithBomCostHistoryView
          id={id}
          company={company}
          currency={defaultCurrency}
        />
      ),
    });
  }

  function showCostHistory(product) {
    costHistoryModal.present({
      title: "Cost History",
      maxWidth: "max-w-7xl",
      subtitle: `[${product.number}] ${product.name}`,
      children: <ProductCostHistoryView product={product} company={company} />,
    });
  }

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const products = data.products.filter((product) => product.isActive);

  return (
    <ProductCostContext.Provider
      value={{
        showProductWithBomCostHistory,
        defaultCurrency,
        showCostHistory,
      }}
    >
      <div className="p-6 h-full overflow-auto">
        <div className="flex justify-between items-center">
          <h1 className="dark:text-gray-200">{data.productLine.name}</h1>
        </div>
        <div>
          {products.length > 0 ? (
            <div>
              <div className="text-right">{AppConfig.exchangeRateNote}</div>
              <div className="mt-4">
                {products.map((product) => (
                  <div
                    className="bg-white dark:bg-gray-800 dark:text-gray-300 rounded-xl p-6 mt-6 mb-10 shadow"
                    key={product.id}
                  >
                    <OneProductView product={product} />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="flex-1 items-center justify-center py-6">
              No products for this product line.
            </div>
          )}
        </div>
      </div>
    </ProductCostContext.Provider>
  );
};

export default ProductDetail;
